// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-row {
  background: var(--ion-color-primary);
  color: white;
}
.toolbar-row ion-button {
  --background: transparent;
}

.title-text {
  font-size: 20px;
  color: var(--ion-color-secondary);
}

.header-block {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-block h3 {
  font-size: 20px;
}

ion-header {
  --box-shadow: none !important;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.0784313725) !important;
}
ion-header.eintracht {
  box-shadow: none !important;
  background: #121212;
  color: #fff;
}
ion-header.eintracht .header-block h3 {
  font-family: AppFontEintrachtOFCSans;
}

.container {
  width: 100%;
}
@media (min-width: 991px) {
  .container {
    max-width: 50%;
    margin: 0 auto;
  }
}

swiper-container {
  --swiper-pagination-bottom: -3px !important;
  --swiper-pagination-color: var(--ion-color-secondary);
}
swiper-container swiper-slide {
  width: 100%;
  max-width: 100% !important;
  margin: 0px 0px 20px;
  padding: 20px;
}

ion-footer {
  padding: 10px;
  box-shadow: none;
  display: flex;
  justify-content: center;
}
ion-footer ion-button {
  width: 100%;
}
@media (min-width: 991px) {
  ion-footer ion-button {
    width: 50%;
    margin: 0 auto;
  }
}

.order-card {
  border: 1px solid #231F20;
  margin-bottom: 15px;
}

ion-content.eintracht {
  --background: #121212;
}
ion-content.eintracht .order-card {
  background: #1A1A1A;
  border-radius: 5px;
  border: 1px solid #383838;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/my-orders/my-orders.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EAIE,oCAAA;EACA,YAAA;AAJF;AAAE;EACE,yBAAA;AAEJ;;AAGA;EACE,eAAA;EACA,iCAAA;AAAF;;AAGA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AACA;EACE,eAAA;AACF;;AAEA;EACE,6BAAA;EACA,mEAAA;AACF;AAAE;EACE,2BAAA;EACA,mBAAA;EACA,WAAA;AAEJ;AAAM;EACE,oCAAA;AAER;;AAGA;EACE,WAAA;AAAF;ACrCE;EDoCF;IAGI,cAAA;IACA,cAAA;EAEF;AACF;;AAAA;EAGE,2CAAA;EACA,qDAAA;AACF;AAAE;EACE,WAAA;EACA,0BAAA;EACA,oBAAA;EACA,aAAA;AAEJ;;AACA;EACE,aAAA;EACA,gBAAA;EAQA,aAAA;EACA,uBAAA;AALF;AAHE;EACE,WAAA;AAKJ;AChEE;ED0DA;IAGI,UAAA;IACA,cAAA;EAOJ;AACF;;AADA;EACE,yBAAA;EACA,mBAAA;AAIF;;AAAE;EACE,qBAAA;AAGJ;AAFI;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;AAIN","sourcesContent":["@import '../../../theme/mixins';\n\n.toolbar-row {\n  ion-button {\n    --background: transparent;\n  }\n  background: var(--ion-color-primary);\n  color: white;\n}\n.title-text {\n  font-size: 20px;\n  color: var(--ion-color-secondary);\n}\n\n.header-block {\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\nh3 {\n  font-size: 20px;\n}\n}\nion-header {\n  --box-shadow: none !important;\n  box-shadow: 0px 4px 45px 0px #00000014 !important;\n  &.eintracht {\n    box-shadow: none !important;\n    background: #121212;\n    color: #fff;\n    .header-block {\n      h3 {\n        font-family: AppFontEintrachtOFCSans;\n      }\n    }\n  }\n}\n.container {\n  width: 100%;\n  @include desktop {\n    max-width: 50%;\n    margin: 0 auto;\n  }\n}\nswiper-container {\n\n\n  --swiper-pagination-bottom: -3px !important;\n  --swiper-pagination-color: var(--ion-color-secondary);\n  swiper-slide {\n    width: 100%;\n    max-width: 100% !important;\n    margin: 0px 0px 20px;\n    padding: 20px;\n  }\n}\nion-footer {\n  padding: 10px;\n  box-shadow: none;\n  ion-button {\n    width: 100%;\n    @include desktop {\n      width: 50%;\n      margin: 0 auto;\n    }\n  }\n  display: flex;\n  justify-content: center;\n}\n\n.order-card {\n  border: 1px solid #231F20;\n  margin-bottom: 15px;\n}\n\nion-content {\n  &.eintracht {\n    --background: #121212;\n    .order-card {\n      background: #1A1A1A;\n      border-radius: 5px;\n      border: 1px solid #383838;\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
